export default __webpack_public_path__ + "static/media/streamer_avatar13.8ee918d4.png";